import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  expiresAt: number | null;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  } | null;
};

const slice = createSlice({
  name: "auth",
  initialState: { accessToken: null, refreshToken: null } as AuthState,
  reducers: {
    setCredentials: (
      state,
      {
        payload: { accessToken, refreshToken, expiresIn },
      }: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        expiresIn?: number;
      }>,
    ) => {
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.expiresAt =
        typeof expiresIn === "number" ? Date.now() + expiresIn * 1000 : null;
    },
    logout: state => {
      state.accessToken = null;
      state.refreshToken = null;
      state.expiresAt = null;
    },
  },
});

export const { setCredentials, logout } = slice.actions;

export const selectAccessToken = (state: { auth: AuthState }) =>
  state.auth.accessToken;

export const selectRefreshToken = (state: { auth: AuthState }) =>
  state.auth.refreshToken;

export const selectTokenExpiresAt = (state: { auth: AuthState }) =>
  state.auth.expiresAt;

export default slice.reducer;
